import * as gov from '#envs/gov';
import * as inhouse from '#envs/inhouse';
import * as line from '#envs/line';
import * as naver from '#envs/naver';
import { buildEnv } from './lib';

const envElem = document.getElementById('__env__');
export const Env = envElem
  ? buildEnv(JSON.parse(envElem.textContent), { gov, inhouse, line, naver })
  : {};
envElem.remove();
